const common = {

    //读取cookie
    getCookie(name) {
        let arr = document.cookie.match(new RegExp("(^| )" + name + "=([^;]*)(;|$)"));
        if (arr != null) return unescape(arr[2]);
        return null;
    },
    //删除cookie
    delCookie(name) {
        var exp = new Date();
        exp.setTime(exp.getTime() - 1);
        var cval = this.getCookie(name);
        console.log(cval)
        if (cval != null)
            document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString() + ";path=/";
    },
    // 转换日期
    getDate(e) {

        let d = new Date(Number(e))
        let year = d.getFullYear();  //取得4位数的年份
        let month = d.getMonth() + 1;  //取得日期中的月份，其中0表示1月，11表示12月
        let date = d.getDate();      //返回日期月份中的天数（1到31）
        return year + "-" + month + "-" + date;
    },

}
export default common;